import { MessageType, type ParsedMessage } from '../types';

/**
 * Parse a WebSocket message from the price feed.
 *
 * Message format: `<type>|<payload>`
 *
 * @param data - Raw message string from WebSocket
 * @returns Parsed message with typed payload
 */
export function parseMessage(data: string): ParsedMessage {
    const separatorIndex = data.indexOf('|');
    if (separatorIndex === -1) {
        return { type: 'unknown', raw: data };
    }

    const type = data.slice(0, separatorIndex);
    const payload = data.slice(separatorIndex + 1);

    switch (type) {
    case MessageType.CONNECTED:
        return { type: '0', pair: payload };
    case MessageType.PRICE:
        return { type: '1', price: parseFloat(payload) };
    case MessageType.ERROR:
        return { type: '2', error: payload };
    case MessageType.PING:
        return { type: '3', timestamp: payload };
    case MessageType.PING_RTT:
        return { type: '4', rtt: parseInt(payload, 10) };
    default:
        return { type: 'unknown', raw: data };
    }
}
